module.exports = require("crypto-js/enc-hex");